import { CSSProperties } from 'react';
import '../styles/spinner.less';

type PropTypes = {
  className: string;
  style?: CSSProperties;
};

const Spinner = ({ className, style }: PropTypes) => {
  return (
    <div className={'ajax-spinner ' + className} style={style}>
      <div>
        <div></div>
      </div>
      <div>
        <div></div>
      </div>
      <div>
        <div></div>
      </div>
      <div>
        <div></div>
      </div>
      <div>
        <div></div>
      </div>
      <div>
        <div></div>
      </div>
      <div>
        <div></div>
      </div>
      <div>
        <div></div>
      </div>
    </div>
  );
};

Spinner.defaultProps = {
  className: '',
  style: null,
};

export default Spinner;
